export function SLABanner() {
  return (
    <div className="bg-brand-mauve text-white text-center py-2 px-4 text-sm font-medium">
      <p>🚚 Entrega garantizada en 1-6 días hábiles tras verificar pago</p>
    </div>
  );
}
